<template>
  <div class="develop">
    <h1>发展历史</h1>
    <ul class="main">
      <li v-for="(item, index) in DataForm" :key="index">
        <div class="title">{{ item.homeData }}</div>
        <div class="time">{{ item.homeTime }}</div>
      </li>
    </ul>
    <div class="more" @click="getMore" v-if="DataAll.length > DataForm.length">查看更多</div>
    <div class="more" @click="getMore" v-else>无更多内容</div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";

const that = getCurrentInstance().appContext.config.globalProperties;

onMounted(() => {
  that.$http.homeAll("ASC").then((res) => {
    DataForm.length = 0;
    if (res.code === 200) {
      // console.log(res.data);
      for(var i=0; i<5; i++){
        DataForm.push(res.data[i])
      }
      DataAll.push(...res.data);
    } else {
      ElMessage({
        message: res.data,
        type: "warning",
      });
    }
  });
});

let DataForm = reactive([]);
let DataAll = reactive([]);

const getMore = () => {
  for(var i= DataForm.length; i<DataForm.length + 5; i++){
    if(DataAll[i]){
        DataForm.push(DataAll[i])
    }
  }
};
</script>

<style lang="less" scoped>
.develop {
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  margin-bottom: 30px;

  h1 {
    font-size: 20px;
    display: inline-block;
    box-sizing: border-box;
    padding: 0px 20px 10px 0;
    border-bottom: 2px solid gray;
  }

  .main {
    width: 100%;
    height: 80%;
    margin-top: 10px;

    li {
      width: 90%;
      height: auto;
      margin: 0 auto 50px;
      position: relative;
      color: gray;
      padding: 10px;
      box-sizing: border-box;
      border: 2px solid gray;
      border-radius: 10px;

      &::after {
        width: 20px;
        height: 30px;
        background-color: red;
        content: "";
        position: absolute;
        bottom: -32px;
        left: calc(50% - 10px);
        background: url("@/assets/homes/arrow-down.png") no-repeat center / 100%
          100%;
      }

      .title {
        width: 60%;
      }

      .time {
        text-align: right;
        font-size: 12px;
      }
    }
  }

  .more {
    text-align: center;
    font-size: 12px;
    color: gray;
  }
}
</style>
